import {
  FETCH_COACHBATCH_REQUEST,
  FETCH_COACHBATCH_SUCCESS,
  FETCH_COACHBATCH_FAILURE,
} from './coachBatchTypes';

const initialState = {
  loading: false,
  coachBatch: null,
  error: '',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COACHBATCH_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_COACHBATCH_SUCCESS:
      return {
        loading: false,
        coachBatch: action.payload,
        error: '',
      };
    case FETCH_COACHBATCH_FAILURE:
      return {
        loading: false,
        coachBatch: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
